import { Link } from "react-router-dom";
import { STUDIO } from "@/lib/studio";
import { Instagram, ArrowRight } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-olive/20 pt-16 pb-8 px-5 md:px-8 bg-ink" data-testid="site-footer">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">

        {/* Col 1: Explore Vow */}
        <div className="flex flex-col gap-6">
          <div className="flex items-center gap-3">
            <span className="h-2 w-2 bg-olive rounded-full" />
            <span className="font-display tracking-[0.22em] text-cream text-sm">{STUDIO.name}</span>
          </div>
          <p className="text-cream/40 text-xs tracking-[0.1em] uppercase leading-relaxed">
            {STUDIO.tagline}
          </p>
          <nav className="flex flex-col gap-3 text-[11px] tracking-[0.22em] uppercase text-cream/60 mt-2">
            <Link to="/" className="hover:text-cream w-fit transition-colors" data-testid="footer-home">Home</Link>
            <Link to="/artists" className="hover:text-cream w-fit transition-colors" data-testid="footer-artists">Artists</Link>
            <a href="/#services" className="hover:text-cream w-fit transition-colors">Services</a>
            <a href="/#gallery" className="hover:text-cream w-fit transition-colors">Work</a>
            <a href="/#contact" className="hover:text-cream w-fit transition-colors">Visit</a>
          </nav>
        </div>

        {/* Col 2: Connect */}
        <div className="flex flex-col gap-6">
          <h3 className="font-display text-sm tracking-[0.22em] uppercase text-cream/80">Connect</h3>
          <div className="flex flex-col gap-4 text-xs text-cream/60 leading-relaxed font-body">
            <a href="#contact" className="hover:text-cream transition-colors w-fit">Contact Us</a>
            <div>
              <p className="mb-1 text-cream/80">Studio Address:</p>
              <p>{STUDIO.address}</p>
            </div>
            <a
              href={`https://instagram.com/${STUDIO.instagram.replace("@", "")}`}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-cream inline-flex items-center gap-2 mt-2 transition-colors w-fit"
              data-testid="footer-instagram"
            >
              <Instagram size={14} strokeWidth={1.5} />
              {STUDIO.instagram}
            </a>
          </div>
        </div>

        {/* Col 3: Legal & Policies */}
        <div className="flex flex-col gap-6">
          <h3 className="font-display text-sm tracking-[0.22em] uppercase text-cream/80">Legal & Policies</h3>
          <nav className="flex flex-col gap-3 text-[11px] tracking-[0.22em] uppercase text-cream/60">
            <Link to="/legal" className="hover:text-cream w-fit transition-colors">Terms & Conditions</Link>
            <Link to="/legal" className="hover:text-cream w-fit transition-colors">Privacy Policy</Link>
          </nav>
        </div>

        {/* Col 4: Book Your Chair */}
        <div className="flex flex-col gap-6">
          <h3 className="font-display text-sm tracking-[0.22em] uppercase text-cream/80">Book Your Chair</h3>
          <div className="flex flex-col gap-5">
            <a
              href="#final-cta"
              className="inline-flex w-fit items-center justify-center gap-2 bg-olive hover:bg-olive-hover text-cream px-6 py-3 text-[10px] sm:text-[11px] tracking-[0.24em] uppercase font-medium transition-all"
            >
              Book a Consultation
              <ArrowRight size={13} strokeWidth={1.8} />
            </a>
            <div className="text-xs text-cream/60 font-body">
              <p className="text-cream/80 mb-1">Studio Hours:</p>
              <p>Mon - Sun: {STUDIO.hours}</p>
            </div>
          </div>
        </div>

      </div>

      <div className="max-w-7xl mx-auto pt-6 border-t border-olive/10 flex flex-col md:flex-row items-center justify-between gap-3 text-[10px] tracking-[0.24em] uppercase text-cream/40">
        <span>© {new Date().getFullYear()} {STUDIO.name} · All rights reserved</span>
        <span>MIRA ROAD-MUMBAI</span>
      </div>
    </footer>
  );
}
